import { render } from "./Records.vue?vue&type=template&id=a14fe546"
import script from "./Records.vue?vue&type=script&lang=js"
export * from "./Records.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.13.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__